/** @jsx jsx */
import { useState, useContext } from 'react'
import { css, jsx } from '@emotion/core'
import { Input, Button, notificationConnect } from '@livechat/design-system'
import validator from 'validator'

import api from '../api'
import { Context } from '../context'

const containerCss = css`
  .add {
    width: 15px;
    margin-right: 5px;
    margin-top: 1px;
  }

  .lc-input {
    width: calc(100% - 15px);
  }

  .box {
    width: 100%;
    display: flex;
    align-items: center;
  }
`

const urlCss = css`
  width: 100%;
  height: 40px;
`

const urlErrorCss = css`
  font-size: 12px;
  color: #d64646;
  margin-top: 5px;
`

const btnCss = css`
  height: 40px;
  margin-left: 10px;
`

const formatNotification = (
  content,
  variant = 'error',
  autoHideDelayTime = 4000,
  removable = true,
  horizontalPosition = 'center',
  verticalPosition = 'top'
) => ({
  type: 'toast',
  autoHideDelayTime,
  payload: {
    variant,
    content,
    horizontalPosition,
    verticalPosition,
    removable,
  },
})

const AddConnection = ({ survey, notificationSystem }) => {
  const { surveyToken } = useContext(Context)
  const [url, setUrl] = useState(survey?.externalService?.url || '')
  const [error, setError] = useState(undefined)
  const [isLoading, setIsLoading] = useState(false)

  const onEnterSubmit = (e) => {
    if (e.keyCode === 13) {
      onSubmit()
    }
  }

  const onSubmit = async () => {
    if (validator.isURL(url) || !url) {
      setIsLoading(true)
      try {
        const resp = await api.createExternalServiceUrl(
          surveyToken,
          survey.id,
          url
        )
        notificationSystem.add(
          formatNotification(
            url
              ? 'External service configured successfully!'
              : 'External service removed successfully!',
            'success'
          )
        )
      } catch (err) {
        notificationSystem.add(formatNotification(error.message))
        console.log(err)
      }
      setIsLoading()
      setError()
    } else {
      setError('Please enter a valid URL.')
    }
  }

  return (
    <div css={containerCss}>
      <div className="box">
        <Input
          css={urlCss}
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          onKeyDown={onEnterSubmit}
          placeholder="https://mybackend.com/endpoint"
          description="After completing the survey, the answer will be sent in the POST request to the supplier's address."
          error={error}
          data-cy="sandbox-survey-name-input"
        />
        <Button onClick={onSubmit} css={btnCss} loading={isLoading}>
          Save
        </Button>
      </div>
      {error && <span css={urlErrorCss}>{error}</span>}
    </div>
  )
}

export default notificationConnect(AddConnection)
